
const DAY_MAP = {
    'Mon': 'Monay',
    'Tue': 'Tuesday',
    'Wed': 'Wednesday',
    'Thu': 'Thursday',
    'Fri': 'Friday',
    'Sat': 'Saturday',
    'Sun': 'Sunday'
}

const MONTH_MAP = {
    'Jan': 'January',
    'Feb': 'February',
    'Mar': 'March',
    'Apr': 'April',
    'May': 'May',
    'Jun': 'June',
    'Jul': 'July',
    'Aug': 'August',
    'Sep': 'September',
    'Oct': 'October',
    'Nov': 'November',
    'Dec': 'December'
}

const formatExamDate = (examDate) => {
    examDate = examDate.split('T');
    return examDate[0]
    const day = DAY_MAP[examDate[0]];   
    const month = MONTH_MAP[examDate[1]];
    const date = examDate[2];
    const year = examDate[3];
    return `${day}, ${month} ${date}, ${year}`;
}

export default formatExamDate;